import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 1. Define the shape of the state
export interface IServiceState {
  value: number; // This will hold the index of the selected service
}

// 2. Set the initial state
const initialState: IServiceState = {
  value: 0, // Default to showing the first service
};

// 3. Create the slice
export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    /**
     * Reducer to update the selected service index.
     * It takes the current state and an action with a number payload.
     * @param state - The current state of the slice.
     * @param action - The action dispatched, containing the new index as payload.
     */
    setSelectedService: (state, action: PayloadAction<number>) => {
      state.value = action.payload;
    },
  },
});

// 4. Export the action creator and the reducer
export const { setSelectedService } = serviceSlice.actions;

export default serviceSlice.reducer;